import { openBlock as o, createElementBlock as l, createElementVNode as r, normalizeClass as k, renderSlot as g, resolveComponent as _, createBlock as p, withCtx as h, pushScopeId as L, popScopeId as B, createSlots as I, normalizeStyle as O, resolveDynamicComponent as F, createCommentVNode as S, createVNode as v, Fragment as b, renderList as C, toDisplayString as $, createTextVNode as D, createStaticVNode as j, mergeProps as R } from "vue";
const f = (t, n) => {
  const e = t.__vccOpts || t;
  for (const [i, a] of n)
    e[i] = a;
  return e;
}, A = {
  name: "StatusEntry",
  props: {
    isClickable: { type: Boolean, default: !1 },
    isError: { type: Boolean, default: !1 },
    isWarning: { type: Boolean, default: !1 },
    isSuccess: { type: Boolean, default: !1 }
  },
  computed: {
    containerClass() {
      return this.isClickable ? "status-entry__container--clickable" : "";
    }
  }
}, M = { class: "status-entry" }, N = { class: "status-entry__icon" }, Z = { class: "status-entry__content" };
function H(t, n, e, i, a, s) {
  return o(), l("div", M, [
    r("div", {
      class: k([s.containerClass, "status-entry__container"]),
      onClick: n[0] || (n[0] = (u) => t.$emit("clicked"))
    }, [
      r("div", N, [
        g(t.$slots, "icon", {}, void 0, !0)
      ]),
      r("div", Z, [
        g(t.$slots, "content", {}, void 0, !0)
      ])
    ], 2),
    g(t.$slots, "additional", {}, void 0, !0)
  ]);
}
const U = /* @__PURE__ */ f(A, [["render", H], ["__scopeId", "data-v-83af2213"]]), J = {
  name: "StatusToggle",
  components: {
    StatusEntry: U
  },
  props: {
    opened: { type: Boolean, default: !0 }
  }
}, G = (t) => (L("data-v-fc708390"), t = t(), B(), t), z = /* @__PURE__ */ G(() => /* @__PURE__ */ r("path", { d: `M23.32849,16.70709,13.12115,26.91425a.50007.50007,0,0,1-.70715,0l-2.82806-2.8285a.5.5
          ,0,0,1,0-.70709L16.96436,16,9.58594,8.62134a.5.5,0,0,1,0-.70709L12.414,
          5.08575a.50007.50007,0,0,1,.70715,0L23.32849,15.29291A.99988.99988,0,
          0,1,23.32849,16.70709Z` }, null, -1)), P = [
  z
];
function q(t, n, e, i, a, s) {
  const u = _("StatusEntry");
  return o(), p(u, {
    class: "status-toggle",
    "is-clickable": "",
    onClicked: n[0] || (n[0] = (c) => t.$emit("clicked"))
  }, {
    icon: h(() => [
      (o(), l("svg", {
        width: "24px",
        height: "24px",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        class: k(["status-toggle__icon", { "status-toggle__icon--opened": e.opened }])
      }, P, 2))
    ]),
    _: 1
  });
}
const K = /* @__PURE__ */ f(J, [["render", q], ["__scopeId", "data-v-fc708390"]]), W = {
  name: "EntryDropUp",
  components: { StatusEntry: U },
  props: {
    hideDropup: { type: Boolean, default: !1 }
  },
  data() {
    return {
      showDropUp: !1
    };
  },
  computed: {
    hasDropUpData() {
      return this.$slots.dropUp !== void 0 && !this.hideDropup;
    },
    entryClass() {
      return this.showDropUp ? "entry-dropup--open" : "";
    }
  },
  methods: {
    async toggle() {
      this.showDropUp = !this.showDropUp, this.showDropUp && !this.hideDropup && this.$refs.dropup && (await this.$nextTick(), this.$refs.dropup.style.bottom = `${window.innerHeight - this.$refs.entryDropup.$el.getBoundingClientRect().y}px`);
    }
  }
}, Q = {
  ref: "dropup",
  class: "entry-dropup__dropup",
  rel: "dropup"
};
function X(t, n, e, i, a, s) {
  const u = _("StatusEntry");
  return o(), p(u, {
    ref: "entryDropup",
    class: k(["entry-dropup", s.entryClass]),
    "is-clickable": !e.hideDropup,
    onClicked: s.toggle
  }, I({
    icon: h(() => [
      g(t.$slots, "icon", {}, void 0, !0)
    ]),
    content: h(() => [
      g(t.$slots, "content", {}, void 0, !0)
    ]),
    _: 2
  }, [
    s.hasDropUpData && a.showDropUp ? {
      name: "additional",
      fn: h(() => [
        r("div", Q, [
          g(t.$slots, "dropUp", {}, void 0, !0)
        ], 512)
      ]),
      key: "0"
    } : void 0
  ]), 1032, ["class", "is-clickable", "onClicked"]);
}
const E = /* @__PURE__ */ f(W, [["render", X], ["__scopeId", "data-v-356b4529"]]), Y = {
  name: "ListElement"
}, tt = { class: "status-list" };
function et(t, n, e, i, a, s) {
  return o(), l("ul", tt, [
    g(t.$slots, "default", {}, void 0, !0)
  ]);
}
const T = /* @__PURE__ */ f(Y, [["render", et], ["__scopeId", "data-v-333b8d4a"]]), st = {
  name: "BarButton",
  components: { List: T, EntryDropUp: E },
  props: {
    name: { type: [String, Number], default: "" },
    link: { type: String, default: "" },
    value: { type: [String, Number, Array], default: "" },
    icon: { type: Object, default: void 0 },
    showDropup: { type: Boolean, default: () => !0 },
    buttonCss: { type: [String, Object], default: "" }
  },
  computed: {
    iconComponent() {
      if (this.icon)
        return this.icon.render();
    },
    hasDropupContent() {
      return Array.isArray(this.value) ? this.value.length > 0 : this.value !== "";
    },
    isDropupHidden() {
      return !!this.link || !this.showDropup || !this.hasDropupContent;
    },
    formattedValue() {
      return [this.value].flat();
    },
    isValueStringArray() {
      return this.formattedValue.length && typeof this.formattedValue[0] == "string";
    }
  }
}, nt = ["href"], ot = ["href", "innerHTML"], rt = ["innerHTML"], at = { key: 0 };
function lt(t, n, e, i, a, s) {
  const u = _("List"), c = _("EntryDropUp");
  return o(), p(c, {
    style: O(e.buttonCss),
    "hide-dropup": s.isDropupHidden
  }, {
    icon: h(() => [
      e.link && s.iconComponent ? (o(), l("a", {
        key: 0,
        class: "bar-button__link",
        target: "_blank",
        href: e.link
      }, [
        (o(), p(F(s.iconComponent)))
      ], 8, nt)) : s.iconComponent ? (o(), p(F(s.iconComponent), { key: 1 })) : S("", !0)
    ]),
    content: h(() => [
      g(t.$slots, "content", {}, () => [
        e.link ? (o(), l("a", {
          key: 0,
          class: "bar-button__link",
          target: "_blank",
          href: e.link,
          innerHTML: e.name
        }, null, 8, ot)) : (o(), l("span", {
          key: 1,
          innerHTML: e.name
        }, null, 8, rt))
      ], !0)
    ]),
    dropUp: h(() => [
      v(u, null, {
        default: h(() => [
          (o(!0), l(b, null, C(s.formattedValue, (y, d) => (o(), l("li", { key: d }, [
            s.isValueStringArray ? (o(), l("pre", at, $(y), 1)) : (o(), l(b, { key: 1 }, [
              r("strong", null, $(y.label) + ":", 1),
              D(" " + $(y.value), 1)
            ], 64))
          ]))), 128))
        ]),
        _: 1
      })
    ]),
    _: 3
  }, 8, ["style", "hide-dropup"]);
}
const ut = /* @__PURE__ */ f(st, [["render", lt], ["__scopeId", "data-v-194278da"]]), it = {
  name: "BranchSvg"
}, ct = {
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, dt = /* @__PURE__ */ r("path", { d: "M17.435,3.325c-1.845,0 -3.326,1.481 -3.326,3.325c0,1.221 0.676,2.286 1.663,2.858l0,0.467c0,1.663 -1.663,3.326 -3.325,3.326c-1.377,-0 -2.468,0.285 -3.325,0.753l-0,-7.871c0.987,-0.572 1.662,-1.637 1.662,-2.858c0,-1.844 -1.48,-3.325 -3.325,-3.325c-1.844,0 -3.325,1.481 -3.325,3.325c0,1.221 0.675,2.286 1.663,2.858l-0,10.884c-0.988,0.572 -1.663,1.637 -1.663,2.858c0,1.844 1.481,3.325 3.325,3.325c1.845,0 3.325,-1.481 3.325,-3.325c0,-0.883 -0.337,-1.663 -0.883,-2.26c0.494,-0.598 1.273,-1.065 2.546,-1.065c3.325,-0 6.65,-3.325 6.65,-6.651l0,-0.467c0.987,-0.572 1.663,-1.637 1.663,-2.858c-0,-1.844 -1.481,-3.325 -3.325,-3.325l-0,0.026Zm-9.976,-1.662c0.909,-0 1.663,0.753 1.663,1.662c-0,0.909 -0.754,1.663 -1.663,1.663c-0.909,-0 -1.662,-0.754 -1.662,-1.663c-0,-0.909 0.753,-1.662 1.662,-1.662Zm0,19.95c-0.909,0 -1.662,-0.753 -1.662,-1.662c-0,-0.909 0.753,-1.663 1.662,-1.663c0.909,0 1.663,0.754 1.663,1.663c-0,0.909 -0.754,1.662 -1.663,1.662Zm9.976,-13.3c-0.91,-0 -1.663,-0.754 -1.663,-1.663c0,-0.909 0.753,-1.662 1.663,-1.662c0.909,-0 1.662,0.753 1.662,1.662c0,0.909 -0.753,1.663 -1.662,1.663Z" }, null, -1), pt = [
  dt
];
function ht(t, n, e, i, a, s) {
  return o(), l("svg", ct, pt);
}
const _t = /* @__PURE__ */ f(it, [["render", ht]]), ft = {
  name: "ToggleElement",
  props: {
    modelValue: { type: Boolean }
  },
  methods: {
    onChange() {
      this.$emit("update:modelValue", !this.modelValue);
    }
  }
}, V = (t) => (L("data-v-c5540238"), t = t(), B(), t), mt = { class: "toggle__container" }, gt = ["checked"], yt = /* @__PURE__ */ V(() => /* @__PURE__ */ r("span", { class: "toggle__track" }, null, -1)), vt = /* @__PURE__ */ V(() => /* @__PURE__ */ r("span", { class: "toggle__thumb" }, null, -1));
function St(t, n, e, i, a, s) {
  return o(), l("div", {
    class: k(["toggle", { "toggle--active": e.modelValue }])
  }, [
    r("label", mt, [
      r("input", {
        class: "toggle__checkbox",
        type: "checkbox",
        checked: e.modelValue,
        onChange: n[0] || (n[0] = (...u) => s.onChange && s.onChange(...u))
      }, null, 40, gt),
      yt,
      vt
    ])
  ], 2);
}
const bt = /* @__PURE__ */ f(ft, [["render", St], ["__scopeId", "data-v-c5540238"]]), kt = typeof localStorage < "u" ? localStorage : { __noSuchMethod__: () => {
} }, $t = {
  props: {
    features: { type: Object, default: () => ({}) }
  },
  data() {
    var t;
    return {
      localFeatures: {},
      defaultFeatures: { ...((t = this.features) == null ? void 0 : t.defaultFeatures) || this.features }
    };
  },
  watch: {
    localFeatures: {
      handler() {
        this.save();
      },
      deep: !0
    }
  },
  mounted() {
    this.assignFeatures();
  },
  methods: {
    resetFeature(t) {
      this.defaultFeatures[t] && (this.localFeatures[t] = { ...this.defaultFeatures[t] }, this.reload());
    },
    updateFeature() {
      this.reload();
    },
    reload() {
      document.location.reload();
    },
    save() {
      kt.setItem("features", JSON.stringify(this.localFeatures));
    },
    assignFeatures() {
      Object.keys(this.features).forEach((t) => {
        t !== "defaultFeatures" && (this.localFeatures[t] = { ...this.features[t] });
      });
    }
  }
}, Ct = {
  name: "FeaturesElement",
  components: { Toggle: bt, List: T, EntryDropUp: E },
  mixins: [$t],
  computed: {
    hasFeatures() {
      return this.localFeatures && Object.keys(this.localFeatures).length > 0;
    }
  },
  methods: {
    splitCamelCase(t) {
      return t.replace(/([a-z])([A-Z])/g, "$1 $2");
    }
  }
}, wt = (t) => (L("data-v-37bedfd5"), t = t(), B(), t), Lt = {
  class: "features__cell",
  style: { "white-space": "nowrap" }
}, Bt = { class: "features__cell features__toggle" }, Ft = { class: "features__cell" }, xt = ["onClick"], Dt = /* @__PURE__ */ wt(() => /* @__PURE__ */ r("svg", {
  width: "20",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}, [
  /* @__PURE__ */ r("path", { d: "M19.87274,10.13794l1.31787-1.48267A8.92382,8.92382,0,0,0,14.93652,7.063,9.0169,9.0169,0,0,0,7.509,19.0083a8.88913,8.88913,0,0,0,5.76245,5.57849,9.01793,9.01793,0,0,0,10.66144-4.34558.9883.9883,0,0,1,1.252-.43762l.9262.38513a1.00842,1.00842,0,0,1,.50147,1.40161A11.99311,11.99311,0,1,1,23.1991,6.39575L24.584,4.83765a.49992.49992,0,0,1,.8595.214l1.47235,6.05273a.5.5,0,0,1-.5462.6145L20.186,10.96643A.5.5,0,0,1,19.87274,10.13794Z" })
], -1)), Ut = [
  Dt
];
function Et(t, n, e, i, a, s) {
  const u = _("Toggle"), c = _("List"), y = _("EntryDropUp");
  return s.hasFeatures ? (o(), p(y, {
    key: 0,
    class: "features"
  }, {
    content: h(() => [
      D(" Features ")
    ]),
    dropUp: h(() => [
      v(c, { class: "features__table" }, {
        default: h(() => [
          (o(!0), l(b, null, C(t.localFeatures, (d, m) => (o(), l("li", {
            key: m,
            class: "features__row"
          }, [
            r("span", Lt, $(s.splitCamelCase(m)), 1),
            r("div", Bt, [
              v(u, {
                modelValue: d.enabled,
                "onUpdate:modelValue": (w) => d.enabled = w,
                onInput: (w) => t.updateFeature(m)
              }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
            ]),
            r("div", Ft, [
              r("button", {
                class: "features__btn",
                title: "Reset to default",
                onClick: (w) => t.resetFeature(m)
              }, Ut, 8, xt)
            ])
          ]))), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  })) : S("", !0);
}
const Tt = /* @__PURE__ */ f(Ct, [["render", Et], ["__scopeId", "data-v-37bedfd5"]]), Vt = {}, It = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none"
}, Ot = /* @__PURE__ */ j('<path d="M26.9143 15.337L16.5718 4.99448L15.5773 4L7.82044 11.7569L4.27348 15.3039C3.90884 15.6685 3.90884 16.2652 4.27348 16.663L11.3674 23.7569L15.5773 28L23.3342 20.2431L23.4668 20.1105L26.9143 16.663C27.279 16.2983 27.279 15.7017 26.9143 15.337ZM15.5773 19.547L12.0304 16L15.5773 12.453L19.1243 16L15.5773 19.547Z" fill="#2684FF"></path><path d="M15.5774 12.4531C13.257 10.1327 13.257 6.35365 15.5443 4.0332L7.78735 11.7901L11.9973 16.0001L15.5774 12.4531Z" fill="url(#paint0_linear)"></path><path d="M19.1244 16L15.5774 19.547C17.8978 21.8674 17.8978 25.6464 15.5774 28L23.3674 20.2099L19.1244 16Z" fill="url(#paint1_linear)"></path><defs><linearGradient id="paint0_linear" x1="14.9447" y1="8.85952" x2="9.99111" y2="13.8131" gradientUnits="userSpaceOnUse"><stop offset="0.176" stop-color="#0052CC"></stop><stop offset="1" stop-color="#2684FF"></stop></linearGradient><linearGradient id="paint1_linear" x1="16.2558" y1="23.0892" x2="21.1995" y2="18.1456" gradientUnits="userSpaceOnUse"><stop offset="0.176" stop-color="#0052CC"></stop><stop offset="1" stop-color="#2684FF"></stop></linearGradient></defs>', 4), jt = [
  Ot
];
function Rt(t, n, e, i, a, s) {
  return o(), l("svg", It, jt);
}
const At = /* @__PURE__ */ f(Vt, [["render", Rt]]), x = "https://i22-shoplifters-dashboard-staging.i22hosting.de/api", Mt = {
  name: "StatusToolbar",
  components: {
    StatusToggle: K,
    BarButton: ut,
    Features: Tt
  },
  props: {
    additionalButtons: {
      type: Array,
      default: () => []
    },
    showToolbar: {
      type: Boolean
    },
    features: {
      type: Object,
      default: () => ({})
    },
    jsonUrl: {
      type: String,
      default: "/appmonitoring/status.json"
    },
    envs: {
      type: Array,
      default: () => [
        {
          name: "Backend",
          identifier: "shopBackend"
        },
        {
          name: "Goliath",
          identifier: "goliath"
        }
      ]
    },
    nodeEnv: {
      type: String,
      required: !0
    },
    currentRevision: { type: Object, default: () => {
    } }
  },
  data() {
    return {
      SHOPLIFTERS_DASHBOARD_API_URL: x,
      statusJSON: {},
      showStatusBar: !0,
      instance: null,
      errors: [],
      BranchSvg: _t,
      JiraSvg: At
    };
  },
  computed: {
    currentRevisionData() {
      return Object.keys(this.currentRevision).map((t) => ({
        label: t,
        value: this.currentRevision[t]
      }));
    },
    jiraTicketLink() {
      var t;
      return `${x}/parse-ticket-id?doRedirect=1&branch=${(t = this.currentRevision) == null ? void 0 : t.branch}`;
    },
    allSummaryErrors() {
      var t, n;
      return (t = this.summary) != null && t.error ? [(n = this.summary) == null ? void 0 : n.error] : this.errors;
    },
    nuxtContext() {
      var t, n;
      return ((t = this.root) == null ? void 0 : t.ctx) || ((n = this.$root) == null ? void 0 : n.context) || null;
    },
    nuxtState() {
      var t;
      return ((t = this.nuxtContext) == null ? void 0 : t.nuxtState) || null;
    },
    root() {
      var t;
      return (t = this.instance) == null ? void 0 : t.root;
    },
    summary() {
      var t;
      return ((t = this.statusJSON) == null ? void 0 : t.summary) || null;
    },
    statusError() {
      var t;
      return ((t = this.nuxtState) == null ? void 0 : t.error) || [];
    },
    statusCode() {
      var t;
      return this.nuxtState ? ((t = this.nuxtState.error) == null ? void 0 : t.statusCode) || 200 : null;
    },
    statusCSS() {
      return { backgroundColor: this.statusCode >= 200 && this.statusCode < 299 ? "green" : "red" };
    },
    summaryStatusCSS() {
      var n;
      return { backgroundColor: (n = this.summary) != null && n.status ? "green" : "red" };
    },
    storage() {
      return localStorage || sessionStorage || { __noSuchMethod__: () => {
      } };
    },
    isVisible() {
      let t = !1;
      try {
        t = !!(process !== void 0 && process.server);
      } catch {
      }
      return !t && this.showToolbar;
    },
    externalSys() {
      return this.envs.map((t) => {
        var s, u;
        const n = {
          name: t.name,
          value: "",
          link: "",
          css: { backgroundColor: "grey" }
        }, e = this.statusJSON[t.identifier];
        if (!e)
          return { ...n, value: "System was not found in appmonitoring.json" };
        const i = (e == null ? void 0 : e.url) || ((s = e == null ? void 0 : e.request) == null ? void 0 : s.url) || "", a = (e == null ? void 0 : e.statusCode) === 200 || (e == null ? void 0 : e.status) || ((u = e == null ? void 0 : e.response) == null ? void 0 : u.status);
        return {
          ...n,
          name: `${t.name}<br><small>${this.getEnvFromUrl(i)}</small>`,
          link: i,
          css: { backgroundColor: a ? "green" : "red" }
        };
      });
    }
  },
  mounted() {
    this.isVisible && (this.storage.getItem("hide-status-toolbar") && (this.showStatusBar = !1), this.instance = this.$root, this.fetchStatusJson());
  },
  methods: {
    toggleToolbar() {
      this.showStatusBar = !this.showStatusBar, this.showStatusBar ? this.storage.removeItem("hide-status-toolbar") : this.storage.setItem("hide-status-toolbar", "1");
    },
    fetchStatusJson() {
      fetch(this.jsonUrl).then((t) => t.json()).then((t) => {
        t !== void 0 ? this.statusJSON = t : console.error(t);
      }).catch((t) => {
        console.error(t), this.errors.push(`Could not load file "${this.jsonUrl}"`);
      });
    },
    getEnvFromUrl(t) {
      try {
        const n = new URL(t);
        return /\.\D+$/.test(n.hostname) ? /-(staging|test|preview)[\w]*\./.test(n.hostname) ? n.hostname.replace(/^www./, "").replace(/(.i22hosting.de|.telekom-dienste.de|.de)$/, "").replace(/.*-([^-]+)$/, "$1") : "production" : "dev";
      } catch {
        return "";
      }
    }
  }
}, Nt = { class: "status-toolbar__wrapper" }, Zt = { class: "status-toolbar__content" }, Ht = { class: "status-toolbar__additional-content" };
function Jt(t, n, e, i, a, s) {
  const u = _("StatusToggle"), c = _("barButton"), y = _("Features");
  return s.isVisible ? (o(), l("div", {
    key: 0,
    class: k([{ "status-toolbar--visible": a.showStatusBar }, "status-toolbar"])
  }, [
    r("div", Nt, [
      v(u, {
        opened: a.showStatusBar,
        onClicked: s.toggleToolbar
      }, null, 8, ["opened", "onClicked"]),
      r("div", null, [
        r("div", Zt, [
          s.statusCode ? (o(), p(c, {
            key: 0,
            name: s.statusCode,
            "button-css": s.statusCSS,
            value: s.statusError
          }, null, 8, ["name", "button-css", "value"])) : S("", !0),
          v(c, {
            name: e.nodeEnv,
            "show-dropup": !1
          }, null, 8, ["name"]),
          (o(!0), l(b, null, C(s.externalSys, (d, m) => (o(), p(c, {
            key: m,
            "button-css": d.css,
            name: d.name,
            link: d.link,
            value: d.value
          }, null, 8, ["button-css", "name", "link", "value"]))), 128)),
          s.summary || a.errors ? (o(), p(c, {
            key: 1,
            name: "Summary",
            "button-css": s.summaryStatusCSS,
            value: s.allSummaryErrors
          }, null, 8, ["button-css", "value"])) : S("", !0),
          e.currentRevision && e.currentRevision.branch ? (o(), p(c, {
            key: 2,
            icon: a.BranchSvg,
            value: s.currentRevisionData
          }, null, 8, ["icon", "value"])) : S("", !0),
          v(c, {
            icon: a.JiraSvg,
            link: s.jiraTicketLink
          }, null, 8, ["icon", "link"]),
          v(y, { features: e.features }, null, 8, ["features"])
        ]),
        r("div", Ht, [
          (o(!0), l(b, null, C(e.additionalButtons, (d, m) => (o(), p(c, R({
            key: `additional-button-${m}`
          }, d), null, 16))), 128))
        ])
      ])
    ])
  ], 2)) : S("", !0);
}
const zt = /* @__PURE__ */ f(Mt, [["render", Jt], ["__scopeId", "data-v-05236c21"]]);
export {
  zt as default
};
